import {Component, Host, h, Prop, Element} from '@stencil/core';

@Component({
  tag: 'bam-submit',
  shadow: false,
})
export class BamSubmit {
  @Element() el: HTMLElement
  @Prop() sitekey: string
  @Prop() captchaEnabled: string
  @Prop() callback: string
  captchaUrl: string = 'https://www.google.com/recaptcha/api.js'
  form: HTMLFormElement
  grecaptcha: object

  componentWillLoad() {
    this.form = this.el.closest('form');
    if (this.captchaEnabled) {
      if (!document.querySelector('#invReCap')) {
        const attrs = {
          async: '',
          defer: '',
          id: 'invReCap',
          src: this.captchaUrl
        };
        const reCaptchaScript = document.createElement('script');
        Object.keys(attrs).forEach(key => reCaptchaScript.setAttribute(key, attrs[key]));
        reCaptchaScript.onload = function () {
          console.log('grecaptcha.ready!');
          window.grecaptcha.ready();
        };
        document.head.appendChild(reCaptchaScript);
      }

      window[this.callback] = () => {
        console.log('Captcha Callback!');
        this.form.submit();
      }
    }
  }

  render() {
    return (
      <Host>
        {this.captchaEnabled &&
        <div class="g-recaptcha"
             data-sitekey={this.sitekey}
             data-callback={this.callback}
             data-size="invisible">
        </div> }
        <slot></slot>
      </Host>
    );
  }

}
